import React from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";

import { MessageType } from "./Message";

function VideoMessage(props) {
  const showMessageTime = () => {
    return props.message.type !== MessageType.info;
  };

  const messageTimeClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      default:
        return "";
    }
  };

  const messageBoxClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return  s360ConfigService.config.autoFullScreen? "s360-message-box-received-fs" : "s360-message-box-received";
      default:
        return "";
    }
  };

  const messageContainerClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      default:
        return "";
    }
  };

  const messageBoxStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.sent:
        return {
          background: "#FFFFFF",
          ...config?.customDesign?.videoMessageBoxReceiver
        };
      case MessageType.received:
        return {
          background: "#FFFFFF",
          ...config?.customDesign?.videoMessageBoxSender
        };
      default:
        return {};
    }
  };

  const messageTimeStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.received:
      case MessageType.sent:
      case MessageType.info:
        return config?.customDesign?.videoMessageTime;
      default:
        return {};
    }
  };

  return (
    <div className={messageContainerClassName()}>
      <div
        className={messageBoxClassName()}
        style={messageBoxStyle()}
      >
        <video controls width="250" style={{ width: "100%" }}>
          <source src={props.message.message.text} type="video/mp4" />
          Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
      <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
        {showMessageTime() && (
          <div
            className={messageTimeClassName()}
            style={messageTimeStyle()}
          >
            {dayjs
              .unix(
                Math.trunc(
                  props?.message?.message?.sentTimestamp / 1000
                )
              )
              .format("DD MMM h:mm a")}
          </div>
        )}

        {/* <Retry {...props} /> */}
      </div>
    </div>
  );
}

export default VideoMessage;
